import React, { useEffect, useState } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import CustomButton from '../../../components/customButton';
import InviteUsersBody from './inviteUsersBody';

const InviteUsersModal = ({ isOpen, cancelCallback, confirmCallback, isLoading }) => {
  const [userList, setUserList] = useState([]);

  useEffect(() => {
    setUserList([]);
  }, [isOpen]);

  const handlePreviousClick = () => {
    cancelCallback(false);
  };

  const handleNextClick = () => {
    confirmCallback({ users: userList });
  };

  return (
    <Modal size="lg" id="invite-portal-user-modal" isOpen={isOpen} fade={false} centered>
      <ModalHeader>
        Invite Users
        <p className="subtitle">Invite users to the Campaign Portal.</p>
      </ModalHeader>
      <ModalBody>
        <InviteUsersBody onChangeCB={setUserList} />
      </ModalBody>
      <ModalFooter>
        <CustomButton title={'Cancel'} classes={'btn btn-secondary'} handleClick={handlePreviousClick} />
        <CustomButton
          title={'Submit'}
          classes="btn btn-primary"
          disabled={userList.length === 0}
          loading={isLoading}
          handleClick={handleNextClick}
        />
      </ModalFooter>
    </Modal>
  );
};

export default InviteUsersModal;
